import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "ContentWrapper"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const FlexWrapper = styled.div.withConfig({
  displayName: "OverlayContent__FlexWrapper",
  componentId: "sc-94olsx-0"
})(({
  $cssStyles
}) => Object.assign({
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  height: '100%'
}, $cssStyles));
const DefaultContentWrapper = styled.div.withConfig({
  displayName: "OverlayContent__DefaultContentWrapper",
  componentId: "sc-94olsx-1"
})(({
  theme
}) => {
  return {
    backgroundColor: theme.color['fill-surface-default'],
    padding: theme.space['600'],
    textAlign: 'center',
    boxShadow: theme.boxShadow['400']
  };
});
export const OverlayContent = _ref => {
  let {
      children,
      ContentWrapper = DefaultContentWrapper
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(FlexWrapper, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      children: children
    })
  }));
};